import { createContext, useEffect, useState } from "react";
import topApi from "../../components/api/ToPApi";
import { Payfac, PayfacsResponse } from "../../models/interfaces";

type PayfacContextProps = {

    payfacs: Payfac[];

    loadPayfacs: () => Promise<void>;

    addPayfac: (payfac: Payfac) => Promise<string>;

    updatePayfac: (payfac: Payfac) => Promise<string>;

    deletePayfac: (id: number) => Promise<string>;

};

export const PayfacContext = createContext({} as PayfacContextProps);

export const PayfacProvider = ({ children }: any) => {

    const [payfacs, setPayfacs] = useState<Payfac[]>([]);

    useEffect(() => {

        loadPayfacs();

    }, []);

    const loadPayfacs = async () => {

        const resp = await topApi.get<PayfacsResponse>('/payfac/getPayfacByUser');

        if (resp.status === 200) {

            setPayfacs(resp.data.payfacs);

        }

    };

    const addPayfac = async (payfac: Payfac) => {

        try {

            const resp = await topApi.post('/payfac', { payfac });

            setPayfacs([...payfacs, resp.data.payfac]);

            return "success";

        } catch (e: any) {

            const error = e.response?.data?.error;

            return error || "Ocurrió un error de comunicación.";

        }

    };

    const updatePayfac = async (payfac: Payfac) => {

        try {

            const resp = await topApi.put(`/payfac/${payfac.id}`, { payfac });

            setPayfacs(

                payfacs.map(p =>

                    p.id === payfac.id
                        ? resp.data.payfac
                        : p

                )

            );

            return "success";

        } catch (e: any) {

            const error = e.response?.data?.error;

            return error || "Ocurrió un error.";

        }

    };

    const deletePayfac = async (id: number) => {

        try {

            await topApi.delete(`/payfac/${id}`);

            setPayfacs(prev => prev.filter(p => p.id !== id));

            return "success";

        } catch (e: any) {

            const error = e.response?.data?.error;

            return error || "Ocurrió un error.";

        }

    };

    return (

        <PayfacContext.Provider

            value={{

                payfacs,

                loadPayfacs,

                addPayfac,

                updatePayfac,

                deletePayfac

            }}

        >

            {children}

        </PayfacContext.Provider>

    );

};